import { DOCS } from "../utils/docs";

export default function BottomSheet({ sheetTab, setSheetTab, onClose }) {
  const doc = DOCS[sheetTab];

  return (
    <div
      onClick={onClose}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'flex-end', justifyContent: 'center', zIndex: 1000 }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{ width: '100%', maxWidth: 430, background: '#ffffff', borderRadius: '12px 12px 0 0', height: '70vh', display: 'flex', flexDirection: 'column' }}
      >
        <div style={{ display: 'flex', justifyContent: 'center', padding: '10px 0 6px', flexShrink: 0 }}>
          <div style={{ width: 32, height: 3, background: '#e0e0e0', borderRadius: 12 }} />
        </div>
        <div style={{ padding: '0 20px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
          <span style={{ fontSize: 16, fontWeight: 600, color: '#111111' }}>서비스 안내</span>
          <button onClick={onClose}
            style={{ background: 'none', border: 'none', outline: 'none', fontSize: 40, color: '#bbbbbb', cursor: 'pointer', lineHeight: 1, padding: 0 }}>
            ×
          </button>
        </div>
        <div style={{ padding: '0 20px 14px', flexShrink: 0 }}>
          <div style={{ display: 'flex', background: '#f5f5f5', borderRadius: 12, padding: 3, gap: 3 }}>
            {Object.entries(DOCS).map(([key, val]) => (
              <button key={key} onClick={() => setSheetTab(key)}
                style={{ flex: 1, padding: '7px 4px', fontSize: 15, background: sheetTab === key ? '#111111' : 'transparent', color: sheetTab === key ? '#ffffff' : '#888888', border: 'none', borderRadius: 8, cursor: 'pointer', fontFamily: "'DM Mono', monospace", fontWeight: sheetTab === key ? 500 : 400, outline: 'none', whiteSpace: 'nowrap' }}>
                {val.label}
              </button>
            ))}
          </div>
        </div>
        <div style={{ height: 1, background: '#eeeeee', flexShrink: 0 }} />
        <div style={{ padding: '16px 20px 24px', overflowY: 'auto', flex: 1 }}>
          {doc.sections.map((s, i) => (
            <div key={i} style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 15, fontWeight: 600, color: '#111111', marginBottom: 4, letterSpacing: 0.5 }}>{s.title}</div>
              <div style={{ fontSize: 15, color: '#888888', lineHeight: 1.8 }}>{s.content}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}